import axios from 'axios'

export default {
  namespaced: true,
  state: {
    employeeSalaryReportGrid: [],
    employeeSalaryReport: null,
    pageData: null,
  },
  mutations: {
    setEmployeeSalaryReportGrid(state, payload) {
      state.employeeSalaryReportGrid = payload
    },
    setEmployeeSalaryReport(state, payload) {
      state.employeeSalaryReport = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  getters: {
    employeeSalaryReportGrid: (state) => {
      return state.employeeSalaryReportGrid
    },
    employeeSalaryReport: (state) => {
      return state.employeeSalaryReport
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onEmployeeSalaryReportGrid({commit, rootState}, {limit, page, search, client, project, week, status}) {
      commit('setLoadingAnimationFullPage', true, {root: true})
      let url = rootState.apiDomain + '/api/admin/employee/salary/report/grid?limit=' + limit + '&page=' + page
      if (search) url = url + '&search=' + search
      if (client) {
        url = url + '&filter[]=client_ids:' + client
      }
      if (project) {
        url = url + '&filter[]=project_id:' + project
      }
      if (week) {
        url = url + '&filter[]=week_number:' + week
      }
      if (status) {
        url = url + '&filter[]=bill_status:' + status
      }
      return new Promise((resolve, reject) => {
        axios({url, limit: limit, page: page, method: 'GET'})
          .then((resp) => {
            commit('setEmployeeSalaryReportGrid', resp.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimationFullPage', false, {root: true})
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimationFullPage', false, {root: true})
            reject(err)
          })
      })
    },
    onEmployeeSalaryReport({commit, rootState}, {id, user, project}) {
      commit('setLoadingAnimationFullPage', true, {root: true})
      let url = rootState.apiDomain + '/api/admin/employee/salary/report/' + id + '?'
      if (user) url = url + 'user_ids[]=' + user + '&'
      if (project) url = url + 'project_ids[]=' + project + '&'
      return new Promise((resolve, reject) => {
        axios({url, method: 'GET'})
          .then((resp) => {
            commit('setEmployeeSalaryReport', resp.data)
            commit('setLoadingAnimationFullPage', false, {root: true})
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimationFullPage', false, {root: true})
            reject(err)
          })
      })
    }
  }
}
